import React from 'react';

interface FooterItem {
  key: string;
  label: string;
  href?: string;
}

interface FooterProps {
  className?: string;
  items?: FooterItem[];
  activeKey?: string;
  onSelect?: (key: string) => void;
}

// components/user/Footer: ユーザ向け画面下部ナビゲーション (Figma node 479-65054)
// デフォルト: ホーム / 予約 / レポート / 問診票
// 視覚仕様: 背景 rgba(0,0,0,0.1), アイテムは黒枠 + 角丸10px + 余白 py-20px
export const Footer: React.FC<FooterProps> = ({
  className,
  items = [
    { key: 'home', label: 'ホーム' },
    { key: 'reservation', label: '予約' },
    { key: 'report', label: 'レポート' },
    { key: 'questionnaire', label: '問診票' },
  ],
  activeKey,
  onSelect,
}) => {
  return (
    <footer
      aria-label="ユーザーナビゲーションフッター"
      className={[
        'w-full box-border',
        'bg-[rgba(0,0,0,0.1)]',
        'flex items-center justify-center',
        'px-[30px] py-0',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <nav aria-label="主要メニュー" className="flex gap-[30px] items-stretch">
        {items.map((item) => {
          const isActive = item.key === activeKey;
          const baseClasses = [
            'flex items-center justify-center',
            'px-0 py-[20px]',
            'rounded-[10px] border border-black box-border',
            'min-w-[90px]',
            'text-[16px] font-normal text-black text-center whitespace-pre-wrap select-none',
            'bg-white',
            'transition-colors duration-150',
          ];
          if (isActive) {
            baseClasses.push('outline outline-2 outline-[#c34416]');
          }
          return item.href ? (
            <a
              key={item.key}
              href={item.href}
              onClick={() => {
                if (onSelect) {
                  onSelect(item.key);
                }
              }}
              className={baseClasses.join(' ')}
              aria-current={isActive ? 'page' : undefined}
            >
              {item.label}
            </a>
          ) : (
            <button
              key={item.key}
              type="button"
              onClick={() => onSelect && onSelect(item.key)}
              className={baseClasses.join(' ')}
              aria-pressed={isActive || undefined}
            >
              {item.label}
            </button>
          );
        })}
      </nav>
    </footer>
  );
};

export default Footer;
